import "./CheckIn.css";
import { React, useState,useEffect } from "react";
import DatePicker, { DateObject } from 'react-multi-date-picker';
import OutlinedInput from '@mui/material/OutlinedInput';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import { apiMain } from "../../App";
import { Messages } from "../data/Messages";
import { useSnackbar } from "notistack";
import { useParams } from 'react-router-dom';
import { GetDataPromise, PostDataPromise } from "../Functions/SendingData";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Active_Date from "./Active_Date";
import Past_Date from "./Past_Date";
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { Loading } from "../Loading";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
function CheckIn(props){
  const [value, setValue] = useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [Day,setDay]=useState([]);
  const [Mont,setMont]=useState([]);
  const [colr,setcolr]=useState([]);

  useEffect(() => {
           getDay();
      
 }, [])
 useEffect(() => {

getData();
}, [Day])
useEffect(() =>{
  getPresentType();
},[])

const getDay = () => {
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
    let today =new Date();
setDay([]);
setMont([]);
setcolr([]);
  for (let i = 0; i < 30; i++) {
  let day=0;
  let mon=0;
  i===0 ? today.setDate( today.getDate() ) :  today.setDate( today.getDate()+ 1 );
  //  today.setDate( today.getDate()+ 1 );
    day=today.getDate();
    mon=today.getMonth()+1;
    setDay(prev => [...prev, day + ' / ' + months[mon - 1]]);
    setMont(prev => [...prev, mon]);
    setcolr(prev => [...prev, 'success']);
 }

  }
  const getData = async ( ) => {
    let uparams = new URLSearchParams();

    let today =new Date();

let mon =0;
setLoading(true);
 mon=today.getMonth();
 mon=mon+1;
    let indate =today.getFullYear()+ '-'+ mon + '-'+ today.getDate() ;
    today.setDate( today.getDate()+30);
    mon=today.getMonth();
    mon=mon+1;
       let outdate =today.getFullYear()+ '-'+ mon + '-'+ today.getDate() ;
    uparams.append("Room_Number", localStorage.getItem("Room_Number"));
    uparams.append("Checkindate", indate);
    uparams.append("Checkoutdate", outdate);
      let res = await GetDataPromise(`${apiMain}/api/v1/reservation/selectday?${uparams}`, false);

    let parsed = JSON.parse(res);
   
  let azdate=new Date();
  let tadate =new Date();
  let az=0;
  let ta=0 ;
  let azmon=0;
  let tamon=0;
    if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
        let newData = parsed.data;
         setData(prev => {
                return {
                    ...prev,
                    attr: newData
                }
            }) 

      newData.map((nd) => {
         azdate=new Date( nd['Reserv_Checkindate'])
         tadate=new Date( nd['Reserv_Checkoutdate'])
        az=azdate.getDate()
        ta=tadate.getDate()
        azmon=azdate.getMonth()+1
        tamon=tadate.getMonth()+1
          for (let i = az; i <= ta; i++) {
          setcolr(prev => {
            let temp=prev
           
            if (Mont[Day.indexOf(i)]===azmon  || Mont[Day.indexOf(i)]===tamon)
            { 
              if (nd['Reserv_Type']===1)
              {
                temp[Day.indexOf(i)]='warning'
               
              }
              else
              {
                temp[Day.indexOf(i)]='error'
              }
            }
          
             {<Loading small={true}/>}
           return temp;
        })
        } ;
      })
    }
    setLoading(false);
}
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const params = useParams()
   const [data, setData] = useState();
  const [Room_Number, setRoom_Number] = useState();
  const [updateCount, setUpdateCount] = useState(0);
  const { enqueueSnackbar } = useSnackbar();
  const [dialogLoading, setDialogLoading] = useState(false);
  const [dialogError, setDialogError] = useState({});
  const [Pass_Id, setPass_Id] = useState(0);
 	const [Pass_FName, setPass_FName] = useState("");
   const [Pass_LName, setPass_LName] = useState("");
    const [Pass_Email, setPass_Email] = useState("");
    const [Pass_No, setPass_No] = useState("");
    const [Pass_PhonNo, setPass_PhonNo] = useState("");
    const [Reserv_Checkindate, setReserv_Checkindate] = useState("");
    const [Reserv_Checkoutdate, setReserv_Checkoutdate] = useState("");
    const [Prese_Id, setPrese_Id] = useState(0);
    const [Adults_No, setAdults_No] = useState(0); 
    const [Childern_No, setChildern_No] = useState(0); 
    const [Nights_No, setNights_No] = useState(0);  
    const [Room_No, setRoom_No] = useState(0);  
    const [loading, setLoading] = useState(false);
    const [Reserv_Price, setReserv_Price  ]=useState(0);
    const [Reserv_prepayment, setReserv_prepayment  ]=useState(0);
    const [Reserv_Account, setReserv_Account  ]=useState(0);
    const [Reserv_Id, setReserv_Id  ]=useState(0);
    const [Reserv_Extrabed, setReserv_Extrabed ]=useState(0);
    const [Reserv_ExtraAmount, setReserv_ExtraAmount ]=useState(0);
    const [Reserv_Breakfast, setReserv_Breakfast ]=useState(0);
    const [Reserv_BreakfastAmount, setReserv_BreakfastAmount ]=useState(0);
    const [Com_FName, setCom_FName] = useState("");
    const [Com_LName, setCom_LName] = useState("");
     const [Comm_Pass_No, setCom_Pass_No] = useState("");
   // const [Rtype_Id, setRtype_Id  ]=useState(0);
   const listItems = [];
   const [Companion, setCompanion] = useState([
    { id:1, fname: '', lname: '',pass:'' }
    ]);
    const [PresentTypeData, setPresentTypeData] = useState([]);
    const getPresentType = async ( ) => {
      let res = await GetDataPromise(`${apiMain}/api/v1/presents`, false);
      let parsed = JSON.parse(res);
      if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
       let newData = parsed.data;
     setPresentTypeData(newData)
    
  }
  
  }
  const changeExtraBed =(e)  =>{
    if(e.target.checked) {
     setReserv_Extrabed(1  )
    }
    else
    {
     setReserv_Extrabed(0  )
    }
 
 
 }
 const changeBreakFast =(e)  =>{
   if(e.target.checked) {
    setReserv_Breakfast(1  )
   }
   else
   {
    setReserv_Breakfast(0  )
   }
 
 
 }
 function handleClosecheckin() {
  props.ChangeXpage(0)
}
  const changeCom_Fname = (event) => {

  if (parseInt(event.target.id)>Companion.length)
  {
    //console.log(event.target.id)
   //const data = Object.entries(Companion);
    ///setCompanion(Companion => [...data, { id:2, fname: '', lname: '',pass:'' }]);
    let myid=parseInt(event.target.id)
    Companion.push({ id:myid});
  }
  setCompanion( Companion.map(com =>
    parseInt(event.target.id) ===com.id  ? { ...com , fname: event.target.value } : com
 // com.id === event.target.id ? { ...com, fname: event.target.value } : com
  ));

// console.log(Companion.map(com =>
//   parseInt(event.target.id) ===com.id  ?  com.fname  : ''))
  //  setPrese_Id(event.target.value);
 };
 const changeCom_Lname = (event) => {
//  if (parseInt(event.target.id)>Companion.length)
//  {
//    let myid=parseInt(event.target.id)
//    Companion.push({ id:myid});
//  }
 setCompanion( Companion.map(com =>
   parseInt(event.target.id) ===com.id  ? { ...com , lname: event.target.value } : com
// com.id === event.target.id ? { ...com, fname: event.target.value } : com
 ));

};
const changeCom_Pass_No = (event) => {

  //  if (parseInt(event.target.id)>Companion.length)
  //  {
  //    let myid=parseInt(event.target.id)
  //    Companion.push({ id:myid});
  //  }
   setCompanion( Companion.map(com =>
     parseInt(event.target.id) ===com.id  ? { ...com , pass: event.target.value } : com
  // com.id === event.target.id ? { ...com, fname: event.target.value } : com
   ));
   };
    const changePeres_Id = (event) => {
      setPrese_Id(event.target.value);
   };
     const handleSubmit = (e) => {
        e.preventDefault();
   
        // Add your form submission logic here
    };
    const sendUpdate = async (e) => {
      let formdata = new FormData;
      let formdata_reserv =new FormData;
    //  let keys = Object.keys(data);
      let errors = {};
     // setPass_Id(0);
      formdata.append("Pass_Id", Pass_Id);
      formdata.append("Pass_FName", Pass_FName);
      formdata.append("Pass_LName", Pass_LName);
      formdata.append("Pass_No", Pass_No);
      formdata.append("Pass_Email", Pass_Email);
      formdata.append("Pass_PhonNo", Pass_PhonNo);  

      formdata_reserv.append("Reserv_Id",Reserv_Id);
      formdata_reserv.append("Pass_Id", Pass_Id);
      formdata_reserv.append("Room_Number",localStorage.getItem("Room_Number"));
      formdata_reserv.append("Reserv_Checkindate",Reserv_Checkindate);
      formdata_reserv.append("Reserv_Checkoutdate",Reserv_Checkoutdate);
      formdata_reserv.append("Adults_No",Adults_No);
      formdata_reserv.append("Night_No",Nights_No);
      formdata_reserv.append("Childern_No",Childern_No);
     formdata_reserv.append("prese_Id",Prese_Id);
     formdata_reserv.append("Reserv_Price",Reserv_Price);
     formdata_reserv.append("Reserv_prepayment",Reserv_prepayment);
     formdata_reserv.append("Reserv_Account",Reserv_Account);
     formdata_reserv.append('Reserv_Extrabed',Reserv_Extrabed);
     formdata_reserv.append('Reserv_ExtraAmount',Reserv_ExtraAmount);
     formdata_reserv.append('Reserv_Breakfast',Reserv_Breakfast);
     formdata_reserv.append('Reserv_BreakfastAmount',Reserv_BreakfastAmount);
     formdata_reserv.append("Reserv_Type",2);
    if(Reserv_ExtraAmount===undefined)
    {
      setReserv_ExtraAmount(0)
    }
    if(Reserv_Breakfast===undefined)
    {
      setReserv_Breakfast(0)
    }
    if(Reserv_BreakfastAmount===undefined)
    {
      setReserv_BreakfastAmount(0)
    }
    //  Reserv_Breakfast
    //  Reserv_BreakfastAmount
     formdata_reserv.append("Reserv_Extrabed",Reserv_Extrabed);
  //    formdata_reserv.append("Reserv_ExtraAmount",Reserv_ExtraAmount);
  //  formdata_reserv.append("Reserv_Breakfast",Reserv_Breakfast);
  //  formdata_reserv.append("Reserv_BreakfastAmount",Reserv_BreakfastAmount);



      //        if(Object.keys(errors).length){
      //     setDialogError(errors)
      //     return;
      // }
      // setDialogLoading(true);
      // setDialogError({})
      let response;
    
       if(Pass_Id > 0){
           // update

           response = await PostDataPromise(apiMain + "/api/v1/passenger/update", formdata);

           let parsed = JSON.parse(response);
   
      console.log(formdata_reserv.get('Reserv_Id'))
      // formdata_reserv.append("Pass_Id",parsed.data[0]);
            response = await PostDataPromise(apiMain + "/api/v1/reservation/update", formdata_reserv);
  
       } else {
          // new
  
           response = await PostDataPromise(apiMain + "/api/v1/passenger/insert", formdata);
        let parsed = JSON.parse(response);
         //  console.log('===='+parsed.data[0]);
       
         setPass_Id(parsed.data[0]);
         console.log(Pass_Id)
     formdata_reserv.append("Pass_Id",parsed.data[0]);
          response = await PostDataPromise(apiMain + "/api/v1/reservation/insert", formdata_reserv);
     }
     response = await PostDataPromise(apiMain + "/api/v1/compan/delete", formdata);
        formdata.append("Pass_Id", Pass_Id);
     for (let i = 0; i < Companion.length; i++) {
         formdata.append("Com_FName", Companion[i].fname);
      formdata.append("Com_LName", Companion[i].lname);
      formdata.append("Com_Pass_No", Companion[i].pass);
         response =  await  PostDataPromise(apiMain + "/api/v1/compan/insert", formdata)
     }
    

      setDialogLoading(false);
      let parsed = JSON.parse(response);
      if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
          // okay
          enqueueSnackbar(Messages.success, { variant: 'success' });

          // props.save()
      } else {
          if(parsed.data && typeof parsed.data.message === "string"){
              enqueueSnackbar((parsed.data) ? parsed.data.message : "", { variant: "error" });
          }
          setDialogError((parsed.data) ? parsed.data.message : {})
      }
      setUpdateCount((prev) => prev + 1)
  }
  //  const [count, setCount] = useState(0); // useState returns a pair. 'count' is the current state. 'setCount' is a function we can use to update the state.
  function allitemupdate(
    fname,
    lname,
    pass_no,
    pres_id,
    pass_email,
    pass_phonNo,
    adults_no,
    childern_no,
    reserv_extrabed,
    reserv_extraamount,
    reserv_checkindate,
    reserv_checkoutdate,
    night_no,
    reserv_breakfast,
    reserv_breakfastamount,
    reserv_price,
    reserv_prepayment,
    reserv_account,
     reserv_id,
    pass_id,
    // room_no,
) {
  setPass_LName(lname);
  setPass_FName(fname);

  setPass_No(pass_no);
  setPrese_Id(pres_id);
  setPass_Email(pass_email);
  setPass_PhonNo(pass_phonNo);

  setAdults_No(adults_no);
  setChildern_No(childern_no);
  setReserv_Extrabed(reserv_extrabed);
  setReserv_ExtraAmount(reserv_extraamount);
  setReserv_Checkindate(reserv_checkindate);
  setReserv_Checkoutdate(reserv_checkoutdate);
  setNights_No(night_no);
  setReserv_Breakfast(reserv_breakfast);
  setReserv_BreakfastAmount(reserv_breakfastamount);
  setReserv_Price(reserv_price);
  setReserv_prepayment(reserv_prepayment);
  setReserv_Account(reserv_account);
  setReserv_Id(reserv_id);
    setPass_Id(pass_id);
  getcompanion()
  }
  const  getcompanion = async (e) =>{
     let uparams = new URLSearchParams();

   uparams.append("Pass_Id", Pass_Id);
    let res =await GetDataPromise(`${apiMain}/api/v1/compan/select?${uparams}`, false);
   let parsed = JSON.parse(res);

   if (parsed.data.length>0)
   {
     setCompanion( Companion.map(com =>(1===com.id) ?
       { ...com , fname: parsed.data[0].Com_FName,
        lname:parsed.data[0].Com_LName,pass:parsed.data[0].Com_Pass_No } 
        : com
  ));
 
   for (let index = 1; index < parsed.data.length; index++) {
    Companion.push({ id:index+1, fname: parsed.data[index].Com_FName,
      lname:parsed.data[index].Com_LName,pass:parsed.data[index].Com_Pass_No});
    }

    
   }
   

//   setCompanion(parsed)
  }
  function incrementadults() {
        //setCount(prevCount => prevCount+=1);
        setAdults_No(function (prevCount) {
          return (prevCount += 1);
        });
      }
      function incrementchildern() {
        //setCount(prevCount => prevCount+=1);
        setChildern_No(function (prevCount) {
          return (prevCount += 1);
        });
      }
      function decrementadults() {
        setAdults_No(function (prevCount) {
          if (prevCount > 0) {
            return (prevCount -= 1); 
          } else {
            return (prevCount = 0);
          }
        });
      }
      function decrementchildren() {
        setChildern_No(function (prevCount) {
          if (prevCount > 0) {
            return (prevCount -= 1); 
          } else {
            return (prevCount = 0);
          }
        });
      }
    function incrementNights() {
      //setCount(prevCount => prevCount+=1);
      setNights_No(function (prevCount) {
        return (prevCount += 1);
      });
    }
  
    function decrementNights() {
      setNights_No(function (prevCount) {
        if (prevCount > 0) {
          return (prevCount -= 1); 
        } else {
          return (prevCount = 0);
        }
      });
    }
    function incrementRooms() {
        //setCount(prevCount => prevCount+=1);
        setRoom_No(function (prevCount) {
          return (prevCount += 1);
        });
      }
    
      function decrementRooms() {
        setRoom_No(function (prevCount) {
          if (prevCount > 0) {
            return (prevCount -= 1); 
          } else {
            return (prevCount = 0);
          }
        });
      }
 
    const handleReset = () => {
        // Reset all state variables here
        setPass_FName("");
        setPass_LName("");
        setPass_No("");
        setPass_Email("");
        setPass_PhonNo("");
        setReserv_Checkindate("");
        setReserv_Checkoutdate("");
        // setRType_Id(0);
        setPrese_Id(0);
        setAdults_No(0);
        setNights_No(0);
        setChildern_No(0);
    };

    return (
        <>
       <Box className="CheckIn" style={{textAlign:'left' }}
      component="form"
      sx={{ '& > :not(style)': { m:1 } }}
      noValidate
      autoComplete="off"
    >
      <div style={{float:'left', paddingTop:'20px'}}>

<svg width="80" height="80" viewBox="0 0 161 161" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="80.0977" cy="80.0977" r="69.7625" fill="#EDD682">
<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1" 
/> </circle>
<path d="M103.02 52.8957H99.4139V50.7576H99.9351C100.991 50.7576 101.781 49.7845 101.559 48.7496L101.031 46.2817L101.031 46.2808C100.868 45.5203 100.185 44.968 99.407 44.968H97.7012C96.9226 44.968 96.2397 45.5203 96.077 46.2817L95.5494 48.7487C95.3274 49.7835 96.1157 50.7575 97.1733 50.7575H97.6946V52.8955H93.9505V43.2968C93.9505 41.0127 92.0919 39.1542 89.8079 39.1542H64.9109C62.6268 39.1542 60.7683 41.0127 60.7683 43.2968V52.8957H56.5945V50.7576H57.1158C58.1721 50.7576 58.9618 49.7848 58.7405 48.7496L58.212 46.2817C58.0491 45.5203 57.3662 44.968 56.5877 44.968H54.8824C54.1047 44.968 53.4214 45.5203 53.2582 46.2808L53.2577 46.2817L52.7297 48.7496C52.508 49.7866 53.3 50.7576 54.354 50.7576H54.8752V52.8957H51.2687C50.2685 52.8957 49.4547 53.7091 49.4547 54.7097V59.93C49.4547 60.9307 50.2685 61.744 51.2687 61.744H51.8688V62.8143C51.8688 63.2894 52.2538 63.6738 52.7284 63.6738C53.203 63.6738 53.5879 63.2894 53.5879 62.8143V61.744H58.0015L54.9081 67.3875C54.8266 67.5362 54.8187 67.7145 54.8023 67.8005V74.0555C54.0409 74.3224 53.4902 75.0409 53.4902 75.8926V79.2226C53.4902 80.3004 54.3666 81.1768 55.444 81.1768H98.4778C99.5552 81.1768 100.432 80.3004 100.432 79.2226V75.8926C100.432 75.041 99.8813 74.3227 99.12 74.0555V67.8005C99.1034 67.714 99.0965 67.5375 99.0142 67.3875L95.9204 61.744H100.701V62.8143C100.701 63.2894 101.086 63.6738 101.56 63.6738C102.035 63.6738 102.42 63.2894 102.42 62.8143V61.744H103.02C104.021 61.744 104.835 60.9306 104.835 59.93V54.7097C104.835 53.709 104.021 52.8957 103.02 52.8957ZM97.7013 46.6872H99.36L99.8628 49.0384H97.2438L97.7013 46.6872ZM54.9295 46.6855L56.5307 46.641L57.0439 49.0384H54.4262L54.9295 46.6855ZM58.7912 63.8804H95.1305L96.8085 66.941H57.1132L58.7912 63.8804ZM56.5215 68.6602H97.4008V73.9385H56.5215V68.6602ZM59.7331 62.1613L64.0486 54.2882C64.4739 53.5722 65.2494 53.1289 66.0794 53.1106C66.1922 54.1416 67.0582 54.9497 68.1185 54.9497H73.0384C74.1011 54.9497 74.9685 54.138 75.0782 53.1038H78.8434C78.9531 54.138 79.8205 54.9497 80.8832 54.9497H85.8031C86.8634 54.9497 87.7294 54.1416 87.8422 53.1106C88.6676 53.1289 89.4389 53.568 89.8659 54.2757L94.1887 62.1613H59.7331ZM67.7761 52.8881V51.5996C67.7761 51.4107 67.9298 51.2571 68.1186 51.2571H73.0385C73.2273 51.2571 73.381 51.4107 73.381 51.5996V52.8881C73.381 53.077 73.2273 53.2306 73.0385 53.2306H68.1186C67.9297 53.2306 67.7761 53.077 67.7761 52.8881ZM80.5409 52.8881V51.5996C80.5409 51.4107 80.6946 51.2571 80.8834 51.2571H85.8033C85.9921 51.2571 86.1458 51.4107 86.1458 51.5996V52.8881C86.1458 53.077 85.9921 53.2306 85.8033 53.2306H80.8834C80.6945 53.2306 80.5409 53.077 80.5409 52.8881ZM64.9109 40.8734H89.808C91.1444 40.8734 92.2314 41.9604 92.2314 43.2968V55.0144L91.3657 53.4355C91.3607 53.4262 91.3556 53.4178 91.3506 53.4086C90.6169 52.1757 89.2765 51.407 87.8436 51.3883C87.736 50.352 86.8676 49.538 85.8033 49.538H80.8834C79.8205 49.538 78.9528 50.3501 78.8435 51.3848H75.0784C74.9692 50.3501 74.1015 49.538 73.0385 49.538H68.1186C67.0545 49.538 66.186 50.352 66.0784 51.3883C64.6453 51.407 63.3048 52.176 62.5561 53.4355L62.4874 53.5607V43.2968C62.4875 41.9604 63.5745 40.8734 64.9109 40.8734ZM51.2687 60.025C51.2161 60.025 51.1738 59.9821 51.1738 59.9302V54.7098C51.1738 54.6577 51.2163 54.615 51.2687 54.615H60.2963V57.558L58.944 60.0251H51.2687V60.025ZM98.7129 79.2226C98.7129 79.3519 98.6075 79.4577 98.4778 79.4577H55.444C55.3148 79.4577 55.2094 79.3519 55.2094 79.2226V75.8926C55.2094 75.7634 55.3148 75.6576 55.444 75.6576H98.4778C98.6075 75.6576 98.7129 75.7634 98.7129 75.8926V79.2226ZM103.116 59.93C103.116 59.9821 103.073 60.0249 103.02 60.0249H94.9781L93.9927 58.2274V54.6147H103.02C103.073 54.6147 103.116 54.6576 103.116 54.7095V59.93Z" fill="#2C2C2C"/>
<circle cx="80.0976" cy="80.0976" r="78.5976" stroke="#EDD682" stroke-width="3"/>
<rect x="39.126" y="94.493"   width="78.9903" height="25.838" rx="12.919" fill="#2C2C2C" />
<text x="60.130" y="115.493"  fontSize={24} fontWeight={'bold'} fill="white">{props.Room_No}</text>
</svg>

</div>
        <Stack spacing={1} sx={{ alignItems: 'center' }}></Stack>
      <Stack    direction="row" spacing={1} >
      {/* <Chip  label="Top Room Reservation" color="" style={{width:"150px", fontWeight:"bold",backgroundColor:"#EDD682"}} /> */}
        <Chip className="chipday" label={Day[0]} color={colr[0]}  />
        <Chip className="chipday" label={Day[1]}  color={colr[1]} />
        <Chip className="chipday" label={Day[2]} color={colr[2]}   />
        <Chip className="chipday" label={Day[3]} color={colr[3]}   />
        <Chip className="chipday" label={Day[4]} color={colr[4]}   />
        <Chip className="chipday" label={Day[5]} color={colr[5]}   />
        <Chip className="chipday" label={Day[6]} color={colr[6]}   />
        <Chip className="chipday" label={Day[7]} color={colr[7]}   />
        <Chip className="chipday" label={Day[8]} color={colr[8]}   />
        <Chip className="chipday" label={Day[9]} color={colr[9]}   />
       
         
      </Stack>

      <Stack    direction="row" spacing={1}>
      {/* <Chip  label={"Room Number : " + localStorage.getItem("Room_Number")} color="" style={{width:"150px", fontWeight:"bold",backgroundColor:"#EDD682"}} /> */}
      <Chip className="chipday" label={Day[10]} color={colr[10]}   />
        <Chip className="chipday" label={Day[11]} color={colr[11]}   />
        <Chip className="chipday" label={Day[12]} color={colr[12]}  />
        <Chip className="chipday" label={Day[13]} color={colr[13]}   />
        <Chip className="chipday" label={Day[14]} color={colr[14]}   />
        <Chip className="chipday" label={Day[15]} color={colr[15]}   />
        <Chip className="chipday" label={Day[16]} color={colr[16]}   />
        <Chip className="chipday" label={Day[17]} color={colr[17]}   />
        <Chip className="chipday" label={Day[18]} color={colr[18]}   />
        <Chip className="chipday" label={Day[19]} color={colr[19]}   />
                
      </Stack>
      <Stack    direction="row" spacing={1}>
      {/* <Chip  label={"Room Number : " + localStorage.getItem("Room_Number")} color="" style={{width:"150px", fontWeight:"bold",backgroundColor:"#EDD682"}} /> */}
      <Chip className="chipday" label={Day[20]} color={colr[20]}   />
       <Chip className="chipday" label={Day[21]} color={colr[21]}   />
        <Chip className="chipday" label={Day[22]} color={colr[22]}  />
        <Chip className="chipday" label={Day[23]} color={colr[23]}   />
        <Chip className="chipday" label={Day[24]} color={colr[24]}   />
        <Chip className="chipday" label={Day[25]} color={colr[25]}   />
        <Chip className="chipday" label={Day[26]} color={colr[26]}   />
        <Chip className="chipday" label={Day[27]} color={colr[27]}   />
        <Chip className="chipday" label={Day[28]} color={colr[28]}   />
        <Chip className="chipday" label={Day[29]} color={colr[29]}   />
       
        
      </Stack>
     </Box>
     
        <div className="CheckIn"  style={{ textAlign: 'left',marginTop:'10px',lineHeight:'.6' }}>
            {/* <h1>Reservation</h1> */}
            <fieldset>
                <form action="#" method="get">
                  <div>
                    <label for="firstname">First Name* </label>
                    <label style={{paddingLeft:"130px"}} for="lastname">Last Name*</label>
                    <label style={{paddingLeft:"135px"}} for="PassportNo">Passport No*</label>
                    <label style={{paddingLeft:"100px"}} for="PassportNo">Reserv Type *</label>
                  </div>
                  <div>

                  
                    <input
                        type="text"
                        name="firstname"
                        id="firstname"
                        value={Pass_FName}
                        onChange={(e) =>
                            setPass_FName(e.target.value)
                        }
                        //placeholder="Enter First Name"
                        required
                    />
              
                
                    <input style={{marginLeft:"60px"}}
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={Pass_LName}
                        onChange={(e) =>
                            setPass_LName(e.target.value)
                        }
                        //placeholder="Enter Last Name"
                        required
                        />
                          <input style={{marginLeft:"60px"}}
                        type="text"
                        name="Passportno"
                        id="Passportno"
                        value={Pass_No}
                        onChange={(e) =>
                            setPass_No(e.target.value)
                        }
                        //placeholder="Enter Passport No"
                        required
                    />
               {/* <FormControl sx={{ m: 1, minWidth: 150 }} > */}
    
  
        <Select  style={{width:'180px' ,height:'40px',marginLeft:'30px' , backgroundColor: "rgb(225, 225, 198)" }}
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          value={Prese_Id}
          onChange={changePeres_Id}
          input={<OutlinedInput label="Name" />}
          MenuProps={MenuProps}
        >
          <MenuItem value="">
          <em>None</em>
        </MenuItem>
         {PresentTypeData.map((dat) => (
          <MenuItem key={dat.Prese_Id} value={dat.Prese_Id}>{dat.Prese_Name}</MenuItem>
        ))}
        
        </Select>
      {/* </FormControl> */}
           </div>
           <div>
             <label  for="tel">Email*</label  >
             <label style={{paddingLeft:"160px"}} for="Telephone"> Telephone (mobile number) </label>
                    <label style={{paddingLeft:"10px"}} for="Adults">Adults*</label>
                    <label style={{paddingLeft:"130px"}} for="Childern">Childern*</label>
                    <label style={{paddingLeft:"70px"}} for="Extra Bed">Extra Bed</label>
                    <label style={{paddingLeft:"40px"}} for="Amount">{ Reserv_Extrabed ? 'Amount' :''}</label>


           </div>
                 
                    <input 
                        type="email"
                        name="email"
                        id="email"
                        value={Pass_Email}
                        onChange={(e) =>
                            setPass_Email(e.target.value)
                        }
                        //placeholder="Enter email"
                        required
                    />
                   
                    <input style={{marginLeft:"60px"}}
                        type="tel"
                        name="PhonNo"
                        id="PhonNo"
                        value={Pass_PhonNo}
                        onChange={(e) =>
                            setPass_PhonNo(e.target.value)
                        }
                        //placeholder="Enter Mobile number"
                        required
                    />
  
                     <ButtonGroup>
                        <Button className= "bin" style={{backgroundColor:'gray',color:"white",marginLeft:'40px'}} onClick={incrementadults}>+</Button>
                        <input className="iin" value={Adults_No}></input>
                        <Button  className= "bin"  style={{backgroundColor:'gray',color:"white"}} onClick={decrementadults}>-</Button> 
                    </ButtonGroup>
                    <ButtonGroup>
                        <Button className= "bin" style={{backgroundColor:'gray',color:"white",marginLeft:'70px'}} onClick={incrementchildern}>+</Button>
                        <input className="iin" value={Childern_No}></input>
                        <Button  className= "bin"  style={{backgroundColor:'gray',color:"white"}} onClick={decrementchildren}>-</Button> 
                    </ButtonGroup>
                    <input style={{marginLeft:"30px" , width:'30px'}}
                        type="checkbox"
                        name="Reserv_Extrabed"
                        id="Reserv_Extrabed"
                        value={Reserv_Extrabed}
                        checked={Reserv_Extrabed}
                        onChange={changeExtraBed}
                        //placeholder=""
                        required
                    />
                      <input style={{marginLeft:"50px",width:'100px'}}
                         type= {Reserv_Extrabed ? "number" :"hidden"}
                        name="Reserv_ExtraAmount"
                        id="Reserv_ExtraAmount"
                        value={Reserv_ExtraAmount}
                        onChange={(e) =>
                            setReserv_ExtraAmount(e.target.value)
                        }
                        //placeholder=""
                        required
                    />
                </form>
            </fieldset>
            </div>
            <div className="CheckIn"  style={{ textAlign: 'left',marginTop:'10px',lineHeight:'.6' }}>
                <fieldset>
                <form action="#" method="get">
                  <div>
                    <label for="Chekindate">
                    Chek in date*
                    </label>
                    <label style={{paddingLeft:"120px"}} for="checkoutdate">Chek out date*</label>
                    <label style={{paddingLeft:"90px"}} for="Nights">Nights*</label>
                    <label style={{paddingLeft:"130px"}} for="Rooms">Rooms*</label>
                    <label style={{paddingLeft:"70px"}} for="Breakfast">Breakfast</label>
                    <label style={{paddingLeft:"30px"}} for="Amount">{Reserv_Breakfast ? 'Amount' : ''}</label>
                  </div>
                  <div>

                  <DatePicker
                  style={{height:"35px"}}
                        // inputClass={"rmdp-input "+ classes + " " + className}
                        className={((window.innerWidth < 1550) ? "rmdp-mobile " : "")}
                        name="Checkindate"
                        required={true}
                        disabled={false}
                         calendarPosition="bottom"
                       //  format='YYYY-MM-dd'
                        // minDate={minDate}
                      //  calendar={gregorian} 
                        locale={"en"} 
                    value={Reserv_Checkindate} 
                        onChange={(e) => setReserv_Checkindate(e)}
                   
                        //  range={range}
                        //  rangeHover={range}
                    />
                   
              
                   <DatePicker
                  style={{height:"35px", marginLeft:"60px"}}
                        // inputClass={"rmdp-input "+ classes + " " + className}
                        className={((window.innerWidth < 1550) ? "rmdp-mobile " : "")}
                        name="Checkoutdate"
                        required={true}
                        disabled={false}
                         calendarPosition="bottom"
                       //  format='YYYY-MM-dd'
                        // minDate={minDate}
                      //  calendar={gregorian} 
                        locale={"en"} 
                     value={Reserv_Checkoutdate} 
                   onChange={(Reserv_Checkoutdate) => setReserv_Checkoutdate(Reserv_Checkoutdate)}
                   
                        // range={range}
                        // rangeHover={range}
                    />
                        <ButtonGroup>
                        <Button className= "bin" style={{backgroundColor:'gray',color:"white",marginLeft:'40px'}} onClick={incrementNights}>+</Button>
                        <input className="iin" value={Nights_No}></input>
                        <Button  className= "bin"  style={{backgroundColor:'gray',color:"white"}} onClick={decrementNights}>-</Button> 
                    </ButtonGroup>
                    <ButtonGroup>
                        <Button className= "bin" style={{backgroundColor:'gray',color:"white",marginLeft:'70px'}} onClick={incrementRooms}>+</Button>
                        <input className="iin" value={Room_No}></input>
                        <Button  className= "bin"  style={{backgroundColor:'gray',color:"white"}} onClick={decrementRooms}>-</Button> 
                    </ButtonGroup>
                    <input style={{marginLeft:"30px" , width:'30px'}}
                        type="checkbox"
                        name="Reserv_Breakfast"
                        id="Reserv_Breakfast"
                        value={Reserv_Breakfast}
                        checked={Reserv_Breakfast}
                        onChange={changeBreakFast}
                        //placeholder=""
                        required
                    />
                      <input style={{marginLeft:"50px",width:'100px'}}
                        type= {Reserv_Breakfast ? "number" :"hidden"}
                        name="Reserv_BreakfastAmount"
                        id="Reserv_BreakfastAmount"
                        value={Reserv_BreakfastAmount}
                        onChange={(e) =>
                            setReserv_BreakfastAmount(e.target.value)
                        }
                        //placeholder=""
                        required
                    />
                   
                   
           </div>
                    </form>
            </fieldset>
</div>
<div className="CheckIn"  style={{ textAlign: 'left',marginTop:'10px',lineHeight:'.6' }}>
           
            <fieldset>
                <form action="#" method="get">
                  <div>
                    <label for="pricepernighte">
                    Price per nighte*
                    </label>
                    <label style={{paddingLeft:"100px"}} for="prepayment">prepayment*</label>
                    <label style={{paddingLeft:"115px"}} for="Accountbalance">Account balance*</label>
                  </div>
                  <div>
                 
                  
                    <input
                        type="text"
                        name="pricepernighte"
                        id="pricepernighte"
                        value={Reserv_Price}
                        onChange={(e) =>
                            setReserv_Price(e.target.value)
                        }
                        //placeholder="Enter pricepernighte "
                        required
                    />
              
                
                    <input style={{marginLeft:"60px"}}
                        type="text"
                        name="prepayment"
                        id="prepayment"
                        value={Reserv_prepayment}
                        onChange={(e) =>
                            setReserv_prepayment(e.target.value)
                        }
                        //placeholder="Enter prepayment "
                        required
                        />
                  <input style={{marginLeft:"60px"}}
                        type="text"
                        name="Accountbalance"
                        id="Accountbalance"
                        value={Reserv_Account}
                        onChange={(e) =>
                            setReserv_Account(e.target.value)
                        }
                        //placeholder="Enter Accountbalance"
                        required
                    />
                        <Button  style={{backgroundColor:"#EDD682" , color:"black" , width: "116px" ,marginLeft: "100px"}}
                        type="submit"
                        value="Submit"
                        onClick={(e) => sendUpdate(e)}
                    >
                        confirm
                    </Button>
                    <Stack direction="row" spacing={1} style={{ paddingRight: '400px' }}>
            <Chip label="Exit" color="primary" onClick={handleClosecheckin} sx={{ width: 150, cursor: 'pointer' }} />
          </Stack>
           </div>
            
                </form>
            </fieldset>
            </div>
            <div className="CheckIn"  style={{ textAlign: 'left',marginTop:'10px',lineHeight:'.6' }}>
            <ul>
      {(() => {

        listItems.length=0;
        for (let i = 0; i < Adults_No-1; i++) {
          listItems.push(
            <fieldset>
            <form action="#" method="get">
              <div>
              <label for="firstname"> First Name*   </label>
                    <label style={{paddingLeft:"130px"}} for="lastname">Last Name</label>
                    <label style={{paddingLeft:"145px"}} for="PassportNo">Passport No</label>
              </div>
              <div>
          
              <input
                        type="text"
                        name="firstname"
                        id={i+1}
                        value={(Companion.filter(com => (i+1) === com.id).length ? Companion.filter(com => (i+1) === com.id)[0] : {}).fname}
                        onChange={changeCom_Fname}
                        //placeholder="Enter First Name"
                        required
                    />
              
                
                    <input style={{marginLeft:"60px"}}
                        type="text"
                        name="lastname"
                        id={i+1}
                        value={(Companion.filter(com => (i+1) === com.id).length ? Companion.filter(com => (i+1) === com.id)[0] : {}).lname}
                        onChange={changeCom_Lname }
                        //placeholder="Enter Last Name"
                        required
                        />
                          <input style={{marginLeft:"60px"}}
                        type="text"
                        name="Passportno"
                        id={i+1}
                        value={(Companion.filter(com => (i+1) === com.id).length ? Companion.filter(com => (i+1) === com.id)[0] : {}).pass}
                 
                        onChange={changeCom_Pass_No}
                        //placeholder="Enter Passport No"
                        required
                    />
     
       </div>

            </form>
        </fieldset>
          
          )
        }
        return listItems
      })()}
    </ul>

    </div>
                    
                    

              
     {/* <Box sx={{ width: '1100px', typography: 'body1' ,marginLeft:'20px'}}>
      {/* <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider',fontWeight:'bold' }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="Reservation" value="1" />
            <Tab label="CheckIn" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <Active_Date Room_Number={localStorage.getItem("Room_Number")} allupdate={allitemupdate} set_LName={setPass_LName} set_FName={setPass_FName } />
          </TabPanel>
        <TabPanel value="2">

             <Past_Date Room_Number={params.id}   />
        </TabPanel>
     
      </TabContext    >
    </Box>    */}
                

        </>
  
        
    );

}
export default CheckIn;